import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueGridLayout from "vue-grid-layout";
import CardApp from "@/components/homeCard/cardApp/CardApp";
import CardCalendar from "@/components/homeCard/cardCalendar/CardCalendar";
import CardNotice from "@/components/homeCard/cardNotice/CardNotice";
import CardSchedule from "@/components/homeCard/cardSchedule/CardSchedule";
import CardServe from "@/components/homeCard/cardServe/CardServe";
import CardTool from "@/components/homeCard/cardTool/CardTool";
export default {
  name: "LayoutView",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    CardApp: CardApp,
    CardCalendar: CardCalendar,
    CardNotice: CardNotice,
    CardSchedule: CardSchedule,
    CardServe: CardServe,
    CardTool: CardTool
  },
  props: ["can-drag", "layout-id", "step-upload"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      layout: [],
      show: false,
      cardList: [],
      compId: "",
      editIndex: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.fetchCardList();
    this.fetchLayout();
  },
  destroyed: function destroyed() {},
  methods: {
    // 获取该角色可用卡片
    fetchCardList: function fetchCardList() {
      var _this = this;

      this.$http.get(this.$base.menhuUrl + "/tabCardInfo/findCardsByRole").then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          var arr = [];
          data.resData.forEach(function (e) {
            arr.push({
              compId: e.comId,
              compName: e.comName,
              cardId: e.cardId
            });
          });
          _this.cardList = arr;
        }
      }).catch(function () {});
    },
    // 根据布局id获取布局配置
    fetchLayout: function fetchLayout() {
      var _this2 = this;

      this.loading = true;
      this.$http.get(this.$base.menhuUrl + "/tabCardPosition/findPositionsByLayoutId", {
        params: {
          layoutId: this.layoutId
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          // 转换数组的 key
          data.resData.forEach(function (e, index) {
            data.resData[index].compId = e.comId;
            data.resData[index].i = _this2.roll(10);
            delete data.resData[index].comId;
          });
          _this2.layout = data.resData;
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      }); // setTimeout(() => {
      //   this.layout = [
      //     { "x":1, "y":0, "w":2, "h":1, "i":"i0", "compId":"CardApp", "moved":false },
      //     { "x":0, "y":0, "w":1, "h":1, "i":"i1", "compId":"CardSchedule", "moved":false },
      //     { "x":0, "y":1, "w":1, "h":2, "i":"i2", "compId":"CardNotice", "moved":false },
      //     { "x":1, "y":1, "w":2, "h":1, "i":"i3", "compId":"CardServe", "moved":false },
      //     { "x":1, "y":2, "w":1, "h":1, "i":"i4", "compId":"CardCalendar", "moved":false },
      //     { "x":2, "y":2, "w":1, "h":1, "i":"i5", "compId":"CardTool", "moved":false }
      //   ];
      //   this.loading = false;
      // }, 500);
    },
    // 显示卡片列表
    showCardList: function showCardList(id, index) {
      var _this3 = this;

      this.compId = id ? id : "";
      this.editIndex = index;
      this.$nextTick(function () {
        _this3.show = true;
      });
    },
    // 点击确认
    changeCard: function changeCard() {
      var _this4 = this;

      var cardId = ""; // 判断如果是新增，cardId:选中的卡片cardId( 新增的时候，cardId:cardId )

      this.cardList.map(function (val) {
        // 选中的组件名 与 下来列表中的数据比配，获取其id并保存其id
        if (_this4.compId === val.compId) {
          cardId = val.cardId;
        }
      }); // 新增

      if (this.editIndex === -1) {
        // 新增只有cardId
        this.addGridItem(cardId);
      } else {
        // 如果是编辑会有index
        this.editGridItem(cardId);
      }

      this.show = false;
    },
    // 修改卡片
    editGridItem: function editGridItem(cardId) {
      this.layout[this.editIndex].compId = this.compId;
      this.layout[this.editIndex].cardId = cardId;
    },
    // 新增卡片
    addGridItem: function addGridItem(cardId) {
      this.layout.push({
        x: 0,
        y: 0,
        w: 1,
        h: 1,
        i: this.roll(10),
        cardId: cardId,
        compId: this.compId,
        positionId: ""
      }); // let x = 0,
      //   y = 0,
      //   w = 0,
      //   h = 1,
      //   num = this.roll(10);
      // let maxY = -1,
      //   lastData = [];
      // // 获取到最后一行的数据
      // for (const item of this.layout) {
      //   if (item.y > maxY) {
      //     maxY = item.y;
      //     y = item.y;
      //     lastData = [];
      //   }
      //   lastData.push(item);
      // }
      // // 获取最后一个卡片的位置
      // let maxX = -1;
      // for (const item of lastData) {
      //   if (item.x > maxX) {
      //     maxX = item.x;
      //     x = item.x;
      //     w = item.w;
      //   }
      // }
      // // 如果最后一张卡片在最右边，就在下一行添加
      // if (x + w == 3) {
      //   y = y + 1;
      //   x = 0;
      // } else {
      //   x = x + w;
      // }
      // this.layout.push({
      //   x: x,
      //   y: y,
      //   w: 1,
      //   h: 1,
      //   i: num,
      //   compId: this.cardId
      // });
    },
    // 移除卡片
    moveComp: function moveComp(index) {
      this.layout.splice(index, 1);
    },
    getLayout: function getLayout() {
      return this.layout;
    },
    // 随机数字符串（长度）
    roll: function roll(maxLength) {
      var num = "";

      for (var i = 0; i < maxLength; i++) {
        num += Math.floor(Math.random() * 10);
      }

      return "&_i" + num;
    },
    // 调整大小后事件
    resizedEvent: function resizedEvent(i) {
      // 只有编辑模式才能改变大小，其他情况下不做事件发送给卡片（比如刚进入页面或者切换模板所有的卡片都会触发该事件）
      if (!this.canDrag) {
        return;
      }

      if (this.$refs[i][0].resizedEvent) {
        this.$refs[i][0].resizedEvent();
      }
    }
  },
  watch: {
    layoutId: function layoutId(value) {
      if (value) {
        this.fetchLayout();
      }
    }
  },
  filters: {}
};